"use client";

import OnlineHeaderIcon from "@/public/onlineHeaderIcon.svg";
import BaHeaderIcon from "@/public/baHeaderIcon.svg";
import AcademyHeaderIcon from "@/public/academyHeaderIcon.svg";
import MultiSiteItem from "./MultiSiteItem";
import MultiSiteItemWithPopover from "./MultiSiteItemWithPopover";
import useHoverMenus from "./useHoverMenus";
import MultiSiteItemPopover from "./MultiSiteItemPopover";
import staticUrls from "@/app/util/staticPageUrls";

import AcademyLogo from "../../../public/logos/aopsAcademyLogo.svg";
import BALogo from "../../../public/logos/aops-ba.svg";
import OnlineLogo from "../../../public/logos/Online-Logo-Color.svg";
import {useTopNavHoverContext} from "../contexts/TopNavHoverContext";

// breaking this out because it was getting chunky
const getMenuItems = () => {
	const onlineUrl =
		process.env.AOPS3_INTEGRATION_URL ?? "https://artofproblemsolving.com";

	const products = [
		{
			id: "aopsOnline",
			href: onlineUrl,
			icon: <OnlineHeaderIcon className="h-6" />,
			text: "AoPS Online",
			popover: {
				buttons: [
					{
						buttonLink: "https://artofproblemsolving.com/store",
						buttonText: "Books for Grades 5-12",
					},
					{
						buttonLink: "https://artofproblemsolving.com/school",
						buttonText: "Online Courses",
					},
				],
				siteURL: "https://artofproblemsolving.com/",
				logo: <OnlineLogo className="h-full" />,
				classes: {
					root: "border-[#009FAD]",
					logo: "h-10",
				},
				children:
					"Math texts, online classes, and more for students in grades 5-12",
			},
		},
		{
			id: "ba",
			href: "https://beastacademy.com",
			icon: <BaHeaderIcon className="h-6" />,
			text: "Beast Academy",
			popover: {
				buttons: [
					{
						buttonLink: "https://beastacademy.com/books",
						buttonText: "Books for Ages 6-13",
					},
					{
						buttonLink: "https://beastacademy.com/online",
						buttonText: "Beast Academy Online",
					},
				],
				siteURL: "https://beastacademy.com/",
				logo: <BALogo className="h-full" />,
				classes: {
					root: "border-[#D50032]",
					logo: "h-10",
				},
				children:
					"Engaging math books and online learning for students ages 6-13",
			},
		},
		{
			id: "academy",
			href: "/",
			icon: <AcademyHeaderIcon className="h-6" />,
			text: "AoPS Academy",
			isCurrentSite: true,
			popover: {
				buttons: [
					{
						buttonLink: staticUrls.location,
						buttonText: "Find a Physical Campus",
					},
					{
						buttonLink: "https://virtual.aopsacademy.org/",
						buttonText: "Visit the Virtual Campus",
					},
				],
				siteURL: "https://aopsacademy.org/",
				logo: <AcademyLogo className="h-full" />,
				classes: {
					root: "border-[#719A3D]",
				},
				children:
					"Small live classes for advanced math and language arts learners in grades 1-12",
			},
		},
	];

	return {
		aopsMain: {
			id: "aopsHome",
			href: onlineUrl + "/company",
			text: "Art of Problem Solving",
			shouldAlwaysShowText: true,
		},
		products,
	};
};

const MultiSiteBar = () => {
	const uncontrolledHoverHandlers = useHoverMenus();
	const contextHoverHandlers = useTopNavHoverContext();

	const {
		activeSubmenu,
		isSubmenuOpen,
		onDropdownItemMouseEnter,
		onDropdownItemMouseLeave,
	} = contextHoverHandlers ?? uncontrolledHoverHandlers;

	const {aopsMain, products} = getMenuItems();

	return (
		<div className="flex w-full bg-corporate-gray-300 px-4 text-md text-corporate-gray-500 md:px-6 xl:px-12">
			<MultiSiteItem {...aopsMain} />
			{products.map(({popover, ...props}) => (
				<MultiSiteItemWithPopover
					{...props}
					key={props.id}
					isOpen={isSubmenuOpen && activeSubmenu === props.id}
					onMouseEnter={onDropdownItemMouseEnter(props.id)}
					onMouseLeave={onDropdownItemMouseLeave}
				>
					<MultiSiteItemPopover {...popover} />
				</MultiSiteItemWithPopover>
			))}
		</div>
	);
};

export default MultiSiteBar;
